import { configs } from '@hero/configs';

import { sendPostMessage } from './sendPostMessage';
import { storage } from './storage';

const illegalRedirectParams = ['code', 'token', 'userCode'];

const getSafeRedirectParams = params => {
  illegalRedirectParams.forEach(e => delete params[e]);
  return params;
};

const handleRedirectSignIn = () => {
  const params = new URLSearchParams(window.location.search);
  const isExternal = params.get('externalSource');
  const redirect = params.get('redirect');

  if (isExternal) {
    sendPostMessage({
      type: 'sign-up-success'
    });
  }

  window.location.href = configs.publicLogin.isBackendRedirect
    ? `${configs.backendLoginUrl}?${redirect ? `redirectUrl=${redirect}` : ''}`
    : `${configs.publicUrl}/login`;
};

const logoutAndRedirect = (externalSource = '') => {
  storage.removeUserToken();
  storage.removeOrganizationCode();
  sessionStorage.removeItem('persist-store');

  if (externalSource === 'teams') {
    sendPostMessage({
      message: 'logout-success'
    });
  }

  if (window.location.pathname.includes('/login')) return;

  window.location.href = configs.publicLogin.isBackendRedirect
    ? configs.backendLogoutUrl
    : `${configs.publicUrl}/login`;
};

export { getSafeRedirectParams, handleRedirectSignIn, logoutAndRedirect };
